import script from "./CreateStudent.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateStudent.vue?vue&type=script&lang=ts&setup=true"

import "./CreateStudent.vue?vue&type=style&index=0&id=77a388b3&lang=less&scoped=true"

import exportComponent from "D:\\鹿小岚\\crm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77a388b3"]])

export default __exports__